var SlateHelpers = /** @class */ (function () {
    function SlateHelpers(editor, config) {
        var _this = this;
        this.getCurrentNode = function () {
            var _a = _this, config = _a.config, editor = _a.editor;
            if (config.pluginType === 'custom') {
                // currently not implemented
                return null;
            }
            if (!editor) {
                return null;
            }
            var editorState = editor.value;
            var predicate = config.pluginType === 'component'
                ? function (el) { return el.type === config.type; }
                : config.pluginType === 'data'
                    ? // search for data
                        function (el) {
                            var matches = config.dataMatches(el.data);
                            return matches;
                        }
                    : null;
            if (config.object === 'inline') {
                return editorState.inlines.find(predicate);
            }
            else if (config.object === 'mark') {
                return editorState.marks.find(predicate);
            }
            else if (config.object === 'block') {
                if (config.pluginType === 'data' || config.replaceOnRemove) {
                    return editorState.blocks.find(predicate);
                }
                else {
                    var matchingBlocks = editorState.blocks.map(function (block) {
                        return editorState.document.getClosest(block.key, function (parent) {
                            return predicate(parent);
                        });
                    });
                    if (matchingBlocks.size > 0) {
                        return matchingBlocks.get(0);
                    }
                }
            }
        };
        this.isActive = function () {
            return Boolean(_this.getCurrentNode());
        };
        this.remove = function () {
            var _a = _this, config = _a.config, editor = _a.editor;
            if (config.customRemove) {
                config.customRemove(editor);
            }
            else if (config.pluginType === 'component') {
                if (config.object === 'mark') {
                    editor.removeMark({
                        type: config.type,
                        data: _this.getCurrentNode()
                            ? _this.getCurrentNode().get('data')
                            : undefined,
                    });
                }
                else if (config.object === 'inline') {
                    editor.unwrapInline(config.type);
                }
                else if (config.object === 'block') {
                    if (config.replaceOnRemove) {
                        editor.setBlocks(config.replaceOnRemove);
                    }
                    else {
                        editor.unwrapBlock(config.type);
                    }
                }
            }
            else {
                // not implemented yet for data type
            }
        };
        this.add = function (passedData) {
            var _a = _this, config = _a.config, editor = _a.editor;
            var data = passedData || (config.getInitialData ? config.getInitialData() : null);
            if (_this.isActive()) {
                // is active, we just update the node with the new data
                var node = _this.getCurrentNode();
                if (node.object !== 'mark') {
                    editor.setNodeByKey(node.key, {
                        type: node.type,
                        key: node.key,
                        nodes: node.nodes,
                        data: data,
                    });
                    return;
                }
                // don't know how to update marks data :-o so just remove and re-add
                _this.remove();
            }
            editor.focus();
            _this.addNew(data);
            editor.moveToEnd();
        };
        this.addNew = function (data) {
            var _a = _this, config = _a.config, editor = _a.editor;
            if (config.customAdd) {
                config.customAdd(editor);
            }
            else if (config.pluginType === 'component') {
                var props = data
                    ? {
                        type: config.type,
                        data: data,
                    }
                    : config.type;
                if (config.object === 'mark') {
                    editor.addMark(props);
                }
                else if (config.object === 'inline') {
                    editor.wrapInline(props);
                }
                else if (config.object === 'block') {
                    if (config.replaceOnRemove) {
                        editor.setBlocks(props);
                    }
                    else {
                        editor.wrapBlock(props);
                    }
                }
            }
            else if (config.pluginType === 'data') {
                if (config.object === 'block') {
                    var el = editor.value.blocks.get(0);
                    editor.setBlocks({
                        type: el && el.type,
                        data: el ? el.data.mergeDeep(data) : data,
                    });
                }
                else if (config.object === 'inline') {
                    var el = editor.value.inlines.get(0);
                    editor.setInlines({
                        type: el && el.type,
                        data: el ? el.data.mergeDeep(data) : data,
                    });
                } // not implemented for marks, makes no sense
            }
        };
        this.editor = editor;
        this.config = config;
    }
    return SlateHelpers;
}());
export default SlateHelpers;
//# sourceMappingURL=SlateHelpers.js.map